const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'FOOTPRINT_MY_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'FOOTPRINT_MY_LIST_INIT') {
		return initialState;
	}
	else if (action.type === 'FOOTPRINT_MY_ITEM_SET') {
		let newState = Object.assign({}, state);
		if (action.payload.type === 'add') {
			let index = newState.list.findIndex((value) => value.userdata_id_code === action.payload.pic);
			if (index < 0) {
				newState = initialState;;
			}
		}
		else if (action.payload.type === 'del') {
			let list = newState.list.filter((value) => (value.userdata_id_code !== action.payload.pic));
			newState.list = list;
		}
		return newState;
	}
	else {
		return state;
	}
}
